import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
    };
  }

  static getDerivedStateFromError(error) {
    return { error: error };
  }

  handleReloadApp() {
    document.location.href = '/';
  }

  render() {
    const { strict = false, message = 'Что-то пошло не так...' } = this.props;

    if (this.state.error || strict) {
      return (
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="text-center">
              <h3 className="mt-4">{message}</h3>
              <h3>Пожалуйста, свяжитесь со службой поддержки</h3>
              <div
                style={{ marginTop: '15px', cursor: 'pointer', color: '#7e57c2' }}
                onClick={() => this.handleReloadApp()}
              >
                Перейти на главную страницу
              </div>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
